import { injectable } from 'inversify';
import { v1 as uuid } from 'uuid';

const BrowserTrackIdKey = 'TaggingApp-Logging-BrowserTrackId';

@injectable()
export class TrackingContextProvider {
  browserTrackId: string;

  instanceTrackId: string;

  constructor() {
    this.instanceTrackId = uuid();
    this.browserTrackId = this.getBrowserTrackId();
  }

  private getBrowserTrackId(): string {
    let browserTrackId = localStorage.getItem(BrowserTrackIdKey);
    if (!browserTrackId) {
      browserTrackId = uuid();
      localStorage.setItem(BrowserTrackIdKey, browserTrackId);
    }
    return browserTrackId;
  }
}
